
import React from 'react';

export const Footer = () => (<footer className="bg-black text-white py-8 px-4"><div className="container mx-auto text-center"><p>&copy; {new Date().getFullYear()} coleese. All rights reserved.</p></div></footer>);
